import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const links = [
  { label: 'Inicio', to: '/' },
  { label: 'Servicios', to: '/servicios' },
  { label: 'Acerca de', to: '/acerca' },
  { label: 'Por qué nosotros', to: '/por-que-nosotros' },
  { label: 'Contacto', to: '/contacto' }
];

function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const mergedWithHero = isHome && !scrolled;

  const navClass = ({ isActive }) =>
    `text-sm font-semibold tracking-tight transition-colors ${
      isActive
        ? 'text-primary border-b-2 border-primary pb-1'
        : 'text-slate-200 hover:text-white'
    }`;

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        mergedWithHero
          ? 'border-transparent bg-transparent'
          : 'border-b border-white/10 bg-[#030A16]/90 backdrop-blur-md shadow-[0_12px_30px_rgba(0,0,0,0.35)]'
      }`}
    >
      <div className="relative mx-auto max-w-7xl px-4 py-4 md:px-8">
        <div className="flex items-center justify-between gap-4">
          <Link to="/" className="group flex items-center gap-3" aria-label="Krystal Software">
            <span className="relative block h-12 w-12">
              <img
                src="/assets/images/home/ks_blue.svg"
                alt="Logo Krystal Software"
                className="absolute inset-0 h-12 w-12 object-contain transition-opacity duration-200 group-hover:opacity-0 group-focus-visible:opacity-0 group-active:opacity-100"
              />
              <img
                src="/assets/images/home/ks_white.svg"
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-12 w-12 object-contain opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus-visible:opacity-100 group-active:opacity-0"
              />
            </span>
            <div>
              <p className="text-lg font-extrabold leading-none text-white">Krystal</p>
              <p className="text-lg font-extrabold leading-none text-slate-100">Software</p>
            </div>
          </Link>

          <nav className="hidden items-center gap-6 lg:flex xl:gap-8">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} className={navClass}>
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-5 lg:flex">
            <p className="hidden text-lg font-bold leading-tight text-white xl:block">
              +51 992 242
              <br />
              237
            </p>
            <NavLink
              to="/contacto"
              className="rounded-md bg-primary px-5 py-3 text-sm font-bold text-white transition-all hover:brightness-110"
            >
              Contáctanos
            </NavLink>
          </div>

          <button
            type="button"
            onClick={() => setOpen((value) => !value)}
            className="rounded-md border border-white/20 p-2 text-white lg:hidden"
            aria-label="Abrir menú"
          >
            <span className="material-symbols-outlined">{open ? 'close' : 'menu'}</span>
          </button>
        </div>

        {open && (
          <div className="mt-4 space-y-3 rounded-xl border border-white/10 bg-[#071225]/95 p-4 backdrop-blur lg:hidden">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block text-sm font-semibold ${isActive ? 'text-primary' : 'text-slate-100'}`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <NavLink
              to="/contacto"
              onClick={() => setOpen(false)}
              className="mt-2 inline-block rounded-md bg-primary px-4 py-2 text-sm font-bold text-white"
            >
              Contáctanos
            </NavLink>
          </div>
        )}

      </div>

      {!mergedWithHero && (
        <div className="pointer-events-none absolute left-0 right-0 -bottom-7 h-7 bg-gradient-to-b from-black/35 to-transparent" />
      )}
    </header>
  );
}

export default SiteHeader;
